<template>
    <content-layout>
        <h1 slot="header">{{title}}</h1>

        <div class="row page-container">
            <div class="column small-12 large-8">
                <div class="page" v-html="content"></div>
            </div>
        </div>
    </content-layout>
</template>

<script>
    import ContentLayout from '../../layouts/ContentLayout'
    import pages from '../../api/pages'

    export default {
        name: 'page',

        props: {
            slug: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                'title': null,
                'content': null
            }
        },

        created() {
            this.load();
        },

        methods: {
            /**
             * Reset component data
             */
            reset() {
                Object.assign(this.$data, this.$options.data.apply(this))
            },

            /**
             * Load page data
             */
            load() {
                pages.find(this.slug)
                    .then(response => {
                        this.title = response.data.title
                        this.content = response.data.content
                    })
            }
        },

        watch: {
            'slug': function (val, oldVal) {
                if (val) {
                    this.load();
                } else {
                    this.reset();
                }
            }
        },

        components: {
            ContentLayout
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/pages/Page.vue